import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AclPermissionDetail } from '@y42/acl/models';
import { createAclPermissionDetail } from '@y42/acl/util/create-acl-permission-detail';
import { connectState, InputObservable } from '@y42/angular/util';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'y42-insert-textarea-button',
  templateUrl: './insert-textarea-button.component.html',
  styleUrls: ['./insert-textarea-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsertTextareaButtonComponent {
  @Input() active = false;

  @Input()
  @InputObservable()
  isCanvasEditable = createAclPermissionDetail({ allowed: false });
  private readonly isCanvasEditable$!: Observable<AclPermissionDetail>;

  @Output() protected readonly selectTool = new EventEmitter<void>();

  readonly state = connectState(this, {
    isCanvasEditable: this.isCanvasEditable$,
  });
}
